var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUseCaseIllustrationDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 104,
    viewBox: "0 0 86 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.793L42.4533 13.1169L85.5126 31.8395L43.0593 51.5156L0 32.793Z",
    fill: "#CFCED5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.487305 71.2988L42.9406 51.6228L85.9999 70.3454L43.5466 90.0214L0.487305 71.2988Z",
    fill: "#9F9EAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseCaseIllustrationDisabled);
export default __webpack_public_path__ + "static/media/useCaseIllustrationDisabled.1d2260616065ece0997264690c040287.svg";
export { ForwardRef as ReactComponent };